import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Grid,
  Input,
  Button,
  InputAdornment,
  Typography,
  Hidden
} from "@material-ui/core";
import { Search } from "@material-ui/icons";

import style from "./style";

class BannerSearchComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchType: props.searchType,
      searchPlaceHolder: props.searchPlaceholder,
      searchValue: ""
    };
  }

  toggleSearchCriteria = type => {
    switch (type) {
      default:
        this.setState({ searchType: "chef",searchPlaceHolder: "Search chefs" });
        this.props.changeSearch('chef', 'Search Chefs');
        break;

      case "chef":
        this.setState({ searchType: "chef",searchPlaceHolder: "Search chefs" });
        this.props.changeSearch('chef', 'Search Chefs');
        break;

      case "dish":
        this.setState({ searchType: "dish", searchPlaceHolder: "Search dishes" });
        this.props.changeSearch('dish', 'Search Dishes');
        break;

      case "post":
        this.setState({ searchType: "post", searchPlaceHolder: "Search posts" });
        this.props.changeSearch('post', 'Search posts');
        break;
    }
  };

  handleChange = e => {
    const { value } = e.target;
    this.setState({ searchValue: value });
  };

  handleSearch = () => {
    const { searchType, searchValue } = this.state;

    if (searchValue.trim().length <= 0) {
      return;
    } else {
      switch (searchType) {
        default:
          this.searchChefs(searchValue);
          break;

        case "chef":
          this.searchChefs(searchValue);
          break;

        case "dish":
          this.searchDishes(searchValue);
          break;

        case "post":
          this.searchPosts(searchValue);
          break;
      }
    }
  };

  searchPosts = search => {
    const { history } = this.props;
    history.push("/home/post-search", { search });
  };

  searchDishes = search => {
    const { history } = this.props;
    history.push("/home/dish-search", { search });
  };

  searchChefs = search => {
    const { history } = this.props;
    history.push("/home/chef-search", { search });
  };

  render() {
    return (
      <Grid
        container
        alignItems="center"
        justify="center"
        alignContent="center"
      >
        <form style={{ width: "80%", margin: "0 auto", textAlign: 'center', display: 'table' }} onSubmit={this.handleSearch}>
          <Grid container direction="row">
            <div style={{ width: '70%', margin: '0 auto',float:'left'}}>
              <Grid style={{ width:'75%',float:'left'}} >
                <Input
                 inputProps={{ 'data-test-id': 'banner-search' }}
                  disableUnderline={true}
                  fullWidth={true}
                  style={style.searchText}
                  startAdornment={
                    <InputAdornment position="start">
                      <Search/>
                    </InputAdornment>
                  }
                  placeholder={this.state.searchPlaceHolder}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid style={{ width:'25%',float:'right'}}>
                <Button
                data-test-id={"search-btn"}
                  type="button"
                  color="primary"
                  style={style.btnSearch}
                  variant="contained"
                  fullWidth={true}
                  onClick={this.handleSearch}
                >
                  Search
                </Button>
              </Grid>
            </div>
          </Grid>

          <Hidden lgUp xsDown>
            <Grid container direction="row" style={{ margin: '0 auto', marginTop: "30px", width: '75%', paddingLeft: '10%' }}>
              <Button
                type="button"
                style={
                  this.state.searchType === "chef"
                    ? style.btnSelectedTab
                    : style.btnSimpleTab
                }
                onClick={() => this.toggleSearchCriteria("chef")}
              >
                Chefs
              </Button>
              <Button
                type="button"
                style={
                  this.state.searchType === "dish"
                    ? style.btnSelectedTab
                    : style.btnSimpleTab
                }
                onClick={() => this.toggleSearchCriteria("dish")}
              >
                Dishes
              </Button>
              <Button
                type="button"
                style={
                  this.state.searchType === "post"
                    ? style.btnSelectedTab
                    : style.btnSimpleTab
                }
                onClick={() => this.toggleSearchCriteria("post")}
              >
                Posts
              </Button>
            </Grid>
          </Hidden>

          <Grid container direction="row" style={{ margin: '0 auto', marginTop: "30px", width: '55%', paddingLeft: '10%' }}>
            <Hidden smUp>
              <Grid item xs={12} style={{ marginTop: 5 }}>
                <Button
                data-test-id={"chef-search"}
                  type="button"
                  style={
                    this.state.searchType === "chef"
                      ? style.btnSelected
                      : style.btnSimple
                  }
                  onClick={() => this.toggleSearchCriteria("chef")}
                >
                  Chefs
                </Button>
              </Grid>
              <Grid item xs={12} style={{ marginTop: 5 }}>
                <Button
                data-test-id={"dish-search"}
                  type="button"
                  style={
                    this.state.searchType === "dish"
                      ? style.btnSelected
                      : style.btnSimple
                  }
                  onClick={() => this.toggleSearchCriteria("dish")}
                >
                  Dishes
                </Button>
              </Grid>
              <Grid item xs={12} style={{ marginTop: 5 }}>
                <Button
                data-test-id={"post-search"}
                  type="button"
                  style={
                    this.state.searchType === "post"
                      ? style.btnSelected
                      : style.btnSimple
                  }
                  onClick={() => this.toggleSearchCriteria("post")}
                >
                  Posts
                </Button>
              </Grid>
            </Hidden>


            <Hidden mdDown>
              <Typography component="p" style={style.txtExplore}>

              </Typography>
              <Button
               data-test-id={"btnchef-id"}
                type="button"
                style={
                  this.state.searchType === "chef"
                    ? style.btnSelected
                    : style.btnSimple
                }
                onClick={() => this.toggleSearchCriteria("chef")}
              >
                Chefs
              </Button>
              <Button
               data-test-id={"btndish-id"}
                type="button"
                style={
                  this.state.searchType === "dish"
                    ? style.btnSelected
                    : style.btnSimple
                }
                onClick={() => this.toggleSearchCriteria("dish")}
              >
                Dishes
              </Button>
              <Button
               data-test-id={"btnpost-id"}
                type="button"
                style={
                  this.state.searchType === "post"
                    ? style.btnSelected
                    : style.btnSimple
                }
                onClick={() => this.toggleSearchCriteria("post")}
              >
                Posts
              </Button>
            </Hidden>
          </Grid>
        </form>
      </Grid>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId
  };
};
const BannerSearch = connect(mapStateToProps)(BannerSearchComponent);

export default BannerSearch;
